__turbopack_context__.v({
  "body": "z2kltW_body",
  "bodyPrimary": "z2kltW_bodyPrimary",
  "bodySecondary": "z2kltW_bodySecondary",
  "contentContainer": "z2kltW_contentContainer",
  "root": "z2kltW_root",
  "rootScroll": "z2kltW_rootScroll",
  "scrollContent": "z2kltW_scrollContent",
  "title": "z2kltW_title",
  "titleRow": "z2kltW_titleRow",
});
